<template>
  <iframe
    ref="businessCardIframe"
    :src="businessCardUrl"
    title="Business card generator"
    width="100%"
    height="960px"
  ></iframe>
</template>

<script>
import { parseBusinessCardMessage } from '../../plugins/business-card-message';

export default {
  name: 'BusinessCardIframe',
  data() {
    return {
      // businessCardUrl: `http://localhost/EnBizCard/public/?token=${this.$store.state.user.auth_token}&currency=${window.systemCurrency}`,
      businessCardUrl: `/tools/business-card-generator?token=${this.$store.state.user.auth_token}&currency=${window.systemCurrency}`,
    };
  },
  created() {
    if (this.vcardUuid) {
      this.businessCardUrl = `${this.businessCardUrl}&uuid=${this.vcardUuid}`;
    }
  },
  mounted() {
    window.addEventListener('message', this.handleBusinessCardMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleBusinessCardMessage);
  },
  props: ['vcardUuid'],
  methods: {
    handleBusinessCardMessage(event) {
      const iframe = this.$refs.businessCardIframe;
      let expectedOrigin;

      if (!iframe || !iframe.contentWindow) {
        return;
      }

      try {
        expectedOrigin = new URL(
          process.env.VUE_APP_BUSINESS_CARD_MESSAGE_ORIGIN
            || this.businessCardUrl,
          window.location.origin,
        ).origin;
      } catch (error) {
        return;
      }

      const message = parseBusinessCardMessage(
        event,
        iframe.contentWindow,
        expectedOrigin,
      );

      if (!message) {
        return;
      }

      if (message.type === 'error') {
        this.$emit('business-card-error', message.message);
      } else {
        this.$emit('business-card-ready', message.url);
      }
    },
  },
};
</script>
